import React, { useContext } from 'react';
import "./style.css"
import { AppContext } from '../../../AppContext';

const SFTabs = ({ tabs, activeTabIndex, onTabClick, count, onAddActivityLog, selectedStudentUserName, studentMode }) => {

    // const appContext = useContext(AppContext);

    const handleAddAcitivityLog = (tabIndex) => {
        let tab = tabs[tabIndex];
        console.debug("tab", tab, tabIndex);

        let activityTypeID = 1; // By Assignments
        switch (tabIndex) {
            case 0:
                activityTypeID = 1; // By Assignments
                break;
            case 1:
                activityTypeID = 17; // By Topics
                break;
            case 2:
                activityTypeID = 2; // My Sets
                break;
            case 3:
                activityTypeID = 25; // Recommended For Practice - Only for LTI
                break;
            
        
            default:
                break;
        }
        
        let logPayload = {
            toNomenclatureID: 0, //Clicked
            quizID: 0,
            subjectID: 0,
            topicID: 0,
            categoryID: 0,
            activityTypeID: activityTypeID,
        };

        console.debug("logPayload>>>", logPayload)

        if (onAddActivityLog) {
            onAddActivityLog(logPayload)
        }
    }

    return (
        <div className='sf-tab-container' style={{
            display: tabs && tabs.length > 0 ? "flex" : "none"
        }}>
            {tabs?.map((tab, tabIndex) => {
                if (selectedStudentUserName === "all" && tab.id === 2 && !studentMode) return;
                // if (tab.id === 1) return;
                let className = "sf-tab-btn";
                if (tab.id  === activeTabIndex) {
                    className += " sf-tab-btn-active"
                }
                return (
                    <div
                    key={tab.id} 
                    className={className} onClick={() => {
                        if (tab.id === activeTabIndex) return;
                        onTabClick(tab.id)
                        handleAddAcitivityLog(tab.id)
                    }}>
                        {activeTabIndex !== tab.id ? tab.value : <div>
                                {tab.value} {count !== 0 ? <strong>({count})</strong> : null}
                            </div>}
                    </div>
                );
            })}


        </div>
    );
}

export default SFTabs;
